import React from 'react';
import VaultBrowseCategoryNav from '../VaultBrowseCategoryNav/VaultBrowseCategoryNav';
import VaultActiveFilterChips from '../VaultActiveFilterChips/VaultActiveFilterChips';
import {
    buildVaultCollectibleFilterChips,
    removeVaultCollectibleFilterChip,
} from '../../utils/vaultBrowseCategories';

/**
 * Marketplace-style category sidebar, mobile chips, and active filter chips for collectible browse pages.
 */
export const getVaultCollectibleBrowseExtras = ({
    isDiecastsMode = false,
    formData,
    onFiltersApply,
    onClearFilters,
    hasLikes = false,
    onClearHasLikes,
    categories,
}) => {
    const chips = buildVaultCollectibleFilterChips(formData, isDiecastsMode, { hasLikes });

    const handleRemoveChip = (key) => {
        const result = removeVaultCollectibleFilterChip(formData, key, isDiecastsMode);
        if (result.clearHasLikes) {
            onClearHasLikes?.();
            return;
        }
        onFiltersApply?.(result.data);
    };

    const categoryNavProps = {
        isDiecastsMode,
        formData,
        onFormDataChange: onFiltersApply,
        ...(categories ? { categories } : {}),
    };

    return {
        sidebarBelowNav: <VaultBrowseCategoryNav layout="sidebar" {...categoryNavProps} />,
        belowToolbar: chips.length > 0 ? (
            <VaultActiveFilterChips
                chips={chips}
                onRemove={handleRemoveChip}
                onClearAll={onClearFilters}
            />
        ) : null,
    };
};
